const parseHashSearchParam = (search: string | undefined, key: string): string | null => {
  if (!search) {
    return null;
  }
  const match = search.match(new RegExp(`(?:^|[?&])${key}=([^&]*)`));
  if (!match?.[1]) {
    return null;
  }
  try {
    // Do not use URLSearchParams it will decode the '+' to a space.
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
};

export default parseHashSearchParam;
